const deliveryStatus = {
  Message_DeliveryStatus_Ready: _TL_('Ready'),
  Message_DeliveryStatus_BuildingTheAudience: _TL_('Building the audience'),
  Message_DeliveryStatus_AudienceTooSmall: _TL_('Audience too small'),
  Message_DeliveryStatus_NoActivityInThePast24Hrs: _TL_('No activity in the past 24 hrs'),
  Message_DeliveryStatus_MissingTagOnTheSite: _TL_('Missing tag on the site'),
  Message_DeliveryStatus_MissingCustomEventsOnTheTag: _TL_('Missing custom events on the tag'),
  Message_DeliveryStatus_InactiveDueToTagUnavailable: _TL_('The tag is no longer available'),
  Message_DeliveryStatus_RecalculatingAudienceSize: _TL_('Recalculating audience size'),
  Message_DeliveryStatus_PossibleTagIssue: _TL_('Possible UET tag issue'),
  Message_DeliveryStatus_MissingComponentAudience: _TL_('Missing component audience'),
  Message_DeliveryStatus_ReadyForAudienceCampaignNotSearchCampaign: _TL_('Ready for audience campaigns, but too small for search campaigns'),
  Message_DeliveryStatus_ReadyForSearchCampaignNotAudienceCampaign: _TL_('Ready for search campaigns, but too small for audience campaigns'),
};

const pagination = {
  Grid_NextPage: _TL_('Next page'),
  Grid_Page_Colon: _TL_('Page:'),
  Grid_Page_Number: _TL_('Page number'),
  Grid_Page_Number_Label_Text: _TL_('Page:'),
  Grid_Page: _TL_('Page'),
  Grid_PageOf: _TL_('of'),
  Grid_PreviousPage: _TL_('Previous page'),
};

export const legacyI18nKeys = [
  deliveryStatus,
  pagination,
];
